import api from './api';
import { TeacherNetworkRequest, User, TeacherWithConnectionStatus } from '../types';

export interface ContainerNode {
  id: number;
  title: string;
  parent?: number | null;
  children: ContainerNode[];
  items: any[];
}

export interface ContentTree {
  containers: ContainerNode[];
  items: any[];
}

class NetworkService {
  // Get a teacher's profile with connection status
  async getTeacherProfile(teacherId: number): Promise<TeacherWithConnectionStatus> {
    const response = await api.get(`/teachers/${teacherId}/`);
    return response.data;
  }

  // Get all teachers (for search)
  async getTeachers(search?: string): Promise<User[]> {
    const params: Record<string, string> = {};
    if (search) {
      params.search = search;
    }
    const response = await api.get('/teachers/', { params });
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  // Network Requests
  async sendNetworkRequest(toTeacherId: number): Promise<TeacherNetworkRequest> {
    const response = await api.post('/network-requests/', { to_teacher: toTeacherId });
    return response.data;
  }

  async getSentRequests(): Promise<TeacherNetworkRequest[]> {
    const response = await api.get('/network-requests/sent/');
    return response.data;
  }

  async getReceivedRequests(): Promise<TeacherNetworkRequest[]> {
    const response = await api.get('/network-requests/received/');
    return response.data;
  }

  async acceptRequest(requestId: number): Promise<void> {
    await api.post(`/network-requests/${requestId}/accept/`);
  }

  async rejectRequest(requestId: number): Promise<void> {
    await api.post(`/network-requests/${requestId}/reject/`);
  }

  async cancelRequest(requestId: number): Promise<void> {
    await api.post(`/network-requests/${requestId}/cancel/`);
  }

  // Network Connections
  async getConnections(): Promise<User[]> {
    const response = await api.get('/teacher-network/connections/');
    return response.data;
  }

  async removeConnection(connectionId: number): Promise<void> {
    await api.delete(`/teacher-network/${connectionId}/disconnect/`);
  }

  // Get teacher's public content tree
  async getTeacherPublicContent(teacherId: number, contentType: string): Promise<ContentTree> {
    const response = await api.get(`/teachers/${teacherId}/public-content/${contentType}/`);
    return response.data;
  }
}

const networkService = new NetworkService();
export default networkService;
